import operaBrowserPrivate from "./operaBrowserPrivate";
import operaIdentityPrivate from "./operaIdentityPrivate";
import palette from "./palette";
import powerSavePrivate from "./powerSavePrivate";
import statsPrivate from "./statsPrivate";
import wallpapersPrivate from "./wallpapersPrivate";
export default {
    operaBrowserPrivate,
    palette,
    powerSavePrivate,
    statsPrivate,
    wallpapersPrivate,
    operaIdentityPrivate,
};
